import { z } from "zod";

export const ctaButtonSchema = z
  .object({
    buttonText: z.string(),
    buttonUrl: z.string(),
  })
  .strict();

export type TextComposerCtaButton = z.infer<typeof ctaButtonSchema>;

export const CTA_BUTTON_TEXT_MAX_LENGTH = 25;

const MERGE_TAG_PATTERN = /^\{\{.*\}\}$/;
const HTTP_URL_PATTERN = /^https?:\/\//i;

export interface CtaButtonValidationErrors {
  buttonText?: string;
  buttonUrl?: string;
}

export function validateCtaButton(
  ctaButton: TextComposerCtaButton,
): CtaButtonValidationErrors {
  const errors: CtaButtonValidationErrors = {};
  const trimmedText = ctaButton.buttonText.trim();
  const trimmedUrl = ctaButton.buttonUrl.trim();
  const hasText = trimmedText.length > 0;
  const hasUrl = trimmedUrl.length > 0;

  if (hasText && !hasUrl) {
    errors.buttonUrl = "URL is required when button text is provided";
  }
  if (hasUrl && !hasText) {
    errors.buttonText = "Button text is required when URL is provided";
  }

  if (hasText && trimmedText.length > CTA_BUTTON_TEXT_MAX_LENGTH) {
    errors.buttonText = `Button text cannot exceed ${CTA_BUTTON_TEXT_MAX_LENGTH} characters`;
  }

  if (
    hasUrl &&
    !MERGE_TAG_PATTERN.test(trimmedUrl) &&
    !HTTP_URL_PATTERN.test(trimmedUrl)
  ) {
    errors.buttonUrl = "URL must start with http:// or https://";
  }

  return errors;
}

export function isCtaButtonValid(
  ctaButton: TextComposerCtaButton | undefined,
): boolean {
  if (ctaButton === undefined) return true;
  const errors = validateCtaButton(ctaButton);
  return Object.keys(errors).length === 0;
}
